export default {
  entities: {
    applicationCondition: {
      noActiveConditionAlert: 'У вас нет активных условий',
      card: {
        months: 'Месяцев',
        sumPerMonth: 'сум / мес',
        applicationAmount: 'Сумма заявки',
        downPaymentAmount: 'Сумма предоплаты',
        commission: 'Комиссия',
        creditAmount: 'Сумма рассрочки',
      },
    },
  },
};
